export default __webpack_public_path__ + "static/media/Chirag R. Kathrani.9d3a06be.jpg";